import { Component, OnInit } from '@angular/core';
import { Common } from './studentregistration/Common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})



export class AppComponent implements OnInit {
  async ngOnInit() {
    // await Common.createPDF("UC70", "GOVT.CLG", "NAVEEN");
    // await Common.createPDF();
  }
}
